import {
  checkIsDiscountForAlternateCard,
  DISCOUNT_SOURCE,
  removeDiscountNamePrefix,
} from 'utils/discount';

/** Converter for Square discount items <-> Paytronix discount items. */
export class DiscountItemsConverter {
  /**
   * Converts Square discount items to Paytronix discount items.
   * @param discountItems Square discount line items.
   * @returns Paytronix discount items.
   */
  static squareToPaytronix(discountItems, processingCardNumber) {
    return discountItems.map((discountItem) => {
      const isAlternateCardDiscount = checkIsDiscountForAlternateCard(
        discountItem,
        processingCardNumber
      );

      return {
        type: 'discountItem',
        itemId: discountItem.metadata?.pxId ?? '',
        referenceLine: discountItem.uid,
        name: removeDiscountNamePrefix(discountItem.name ?? ''),
        discountSource: isAlternateCardDiscount
          ? DISCOUNT_SOURCE.OTHER
          : DISCOUNT_SOURCE.LOYALTY,
        walletCode: Number(discountItem?.metadata?.pxWalletCode ?? -1),
        walletQuantity: Number(discountItem?.metadata?.pxQuantityRedeemed ?? 0),
        price: Number(-1 * Number(discountItem.amountMoney?.amount ?? 0)) / 100,
      };
    });
  }
}
